export const getters = {
  IS_AUTH: (state) => state.isAuth,
  USER: (state) => state.user,
  ROLE_NAME: (state) => state.role,
}
